const MirrorIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 9H19.5M19.5 9L17 6.5M19.5 9L17 11.5M14 15H4.5M4.5 15L7 12.5M4.5 15L7 17.5" stroke="currentColor" />
        </svg>
    )
}

export default MirrorIcon